import { createStore } from 'zustand';
import { IncomingStoreTypes } from '../types/store/incoming.types';

const defaultValues = {
  rejectedMessage: {},
};

export const incomingStore = createStore<IncomingStoreTypes>((set) => ({
  ...defaultValues,
  setRejectedMessage: (rejectedMessage) => set({ rejectedMessage }),
}));
